import * as React from "react";
import {SVGProps} from "react";

export const IconChevronDown = (props: SVGProps<SVGSVGElement>) => {
    const {color = "currentColor", width = "1em", height = "1em", ...rest} = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 33.5 33.5"
            fill="none"
            {...rest}
        >
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.792}
                d="M8.625 12.812 17 21.187l8.375-8.375"
            />
        </svg>
    );
};
